import {Component, Type} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ngbd-modal-confirm',
  template: `
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{title}}</h4>
    <button type="button" class="btn-close close" aria-label="Close" aria-describedby="modal-title" (click)="activeModal.dismiss('Cross click')"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <p><strong> {{queryMessage}} <span class="text-primary">"{{libelle}}"</span> ?</strong></p>
   
    <p [innerHTML]="description"></p>
    
  </div>
  <div class="modal-footer">
    <button ngbAutofocus type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('cancel click')">Non</button>
    <button type="button" class="btn btn-danger" (click)="activeModal.close('Ok click')">{{btnMessage}}</button>
  </div>
  `
})
export class NgbdModalConfirm {
  //From Modal:  parameters
  title: string;
  libelle: string;
  queryMessage: string;
  description: string;
  btnMessage : string;

  constructor(public activeModal: NgbActiveModal) {}
}




